import { render, staticRenderFns } from "./MFQuickActions.vue?vue&type=template&id=e81dc730"
import script from "./MFQuickActions.vue?vue&type=script&lang=js"
export * from "./MFQuickActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports